import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../apiConfig";

export default function ToolsPanel() {

  const navigate = useNavigate();

  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTools();
  }, []);

  async function loadTools() {

    try {

      const session = JSON.parse(localStorage.getItem("zedro_session"));

      const res = await fetch(`${API_URL}/api/tools`, {
        headers: {
          Authorization: `Bearer ${session?.token}`
        }
      });

      const json = await res.json();

      if (json.ok) {
        setTools(json.tools || []);
      }

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  }

  if (loading) return <div style={{ padding: 40 }}>Cargando herramientas...</div>;

  return (

    <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>

      <button
        onClick={() => navigate("/dashboard")}
        style={{
          marginBottom: 20,
          padding: "6px 12px",
          borderRadius: 6,
          border: "1px solid #ddd",
          background: "#fff",
          cursor: "pointer"
        }}
      >
        ← Volver al dashboard
      </button>

      <h1 style={{ marginBottom: 30 }}>
        ZEDRO Tools
      </h1>

      {tools.length === 0 && (
        <p>No hay herramientas disponibles.</p>
      )}

      <div style={{ display: "grid", gap: 16 }}>

        {tools.map(tool => (

          <div
            key={tool.id}
            style={{
              padding: 20,
              border: "1px solid #eee",
              borderRadius: 10,
              background: "#fff"
            }}
          >

            <div style={{ fontSize: 18, fontWeight: 600 }}>
              {tool.title}
            </div>

            {tool.description && (
              <div style={{ marginTop: 6, opacity: 0.7 }}>
                {tool.description}
              </div>
            )}

          </div>

        ))}

      </div>

    </div>
  );
}